'use client';

import { useMemo } from 'react';
import { DateRange, DefaultCalendar } from 'ui';

export const DateRangeFilterCalendar = ({
  date,
  setDate,
}: {
  date: DateRange | undefined;
  setDate: (range: DateRange | undefined) => void;
}) => {
  const selected = useMemo(
    () => (date?.from ? { from: date.from, to: date.to } : undefined),
    [date?.from, date?.to],
  );

  return (
    <DefaultCalendar
      mode='range'
      numberOfMonths={1}
      defaultMonth={date?.from}
      selected={selected}
      onSelect={setDate}
    />
  );
};
